import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationDetailIcons = {
  SPARKLE: 'sparkle',
} as const

export type ConversationDetailIconEnum = Enum<typeof ConversationDetailIcons>
